import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import BlogInner from '../Components/Blog/BlogInner'
import ScrollToTop from '../Components/ScrollToTop'
import FooterFour from '../Components/Footer/FooterFour'
import SEO from '../Components/SEO/SEO'

function Blog() {
    return (
        <>
            <SEO 
                title="Travel Blog - Tourm Travel Agency"
                description="Read our travel blog for tips, guides, and stories from around the world. Get inspired for your next adventure."
                url="/blog"
            />
            <HeaderOne />
            <Breadcrumb
                title="Blog Lists View"
            />
            <BlogInner />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Blog
